import { setHeaderMenuStyle } from '@theme/utilities';

const DESKTOP_NAV = window.matchMedia('(min-width: 750px)');

function expandAllNavItems(overflowList) {
  overflowList.querySelectorAll('.menu-list__list-item[slot="overflow"]').forEach((item) => {
    item.removeAttribute('slot');
  });
  const moreItem = overflowList.querySelector('.menu-list__list-item[slot="more"]');
  if (moreItem) moreItem.setAttribute('hidden', '');
}

function applyDesktopNav() {
  const overflowList = document.querySelector('[data-testid="header-menu-overflow-list"]');
  const header = document.querySelector('#header-component');
  if (!header) return;

  header.dataset.menuStyle = 'menu';

  if (!overflowList) return;

  expandAllNavItems(overflowList);
  overflowList.setAttribute('disabled', 'true');
  overflowList.removeAttribute('minimum-reached');
}

function syncDesktopNavOverflow() {
  if (DESKTOP_NAV.matches) {
    applyDesktopNav();
    return;
  }

  const overflowList = document.querySelector('[data-testid="header-menu-overflow-list"]');
  if (overflowList) overflowList.removeAttribute('disabled');
  setHeaderMenuStyle();
}

function watchOverflowList(overflowList) {
  const observer = new MutationObserver(() => {
    if (!DESKTOP_NAV.matches) return;
    if (overflowList.querySelector('.menu-list__list-item[slot="overflow"]')) {
      applyDesktopNav();
    }
  });

  observer.observe(overflowList, {
    subtree: true,
    attributes: true,
    attributeFilter: ['slot', 'minimum-reached', 'disabled'],
  });
}

async function init() {
  if (DESKTOP_NAV.matches) {
    applyDesktopNav();
  }

  await customElements.whenDefined('overflow-list');

  const overflowList = document.querySelector('[data-testid="header-menu-overflow-list"]');
  if (overflowList) watchOverflowList(overflowList);

  syncDesktopNavOverflow();
}

DESKTOP_NAV.addEventListener('change', init);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
